module.exports = __webpack_public_path__ + "img/landingpage-bg.ae97e263.png";